import React from 'react';
import Popup from 'reactjs-popup';
import {contentStyle, overlayStyle, Wrapper} from './styled';

type TooltipProps = {
  children: any;
  position?:
    | 'center center'
    | 'top left'
    | 'top center'
    | 'top right'
    | 'right top'
    | 'right center'
    | 'right bottom'
    | 'bottom left'
    | 'bottom center'
    | 'bottom right'
    | 'left top'
    | 'left center'
    | 'left bottom';
  label?: React.ReactNode | JSX.Element | string | null;
  className?: string;
};

const defaultProps: Partial<TooltipProps> = {
  position: 'center center',
  label: '',
  className: undefined,
  children: null,
};

function getReadableTooltipPosition(readableTooltipPosition?: ClientRect) {
  if (!readableTooltipPosition) {
    return;
  }

  const left = readableTooltipPosition.left;
  const right = readableTooltipPosition.right;

  if (left >= 280) {
    return 'top right';
  }

  if (right >= 280) {
    return 'top left';
  }

  if (left >= 135 && right >= 135) {
    return 'top center';
  }
}

function Tooltip({position, label, children, className}: TooltipProps) {
  const tooltipRef = React.useRef<HTMLDivElement>(null);
  const [currPosition, setCurrPosition] = React.useState(position);

  React.useEffect(() => {
    const currentCoordinates = tooltipRef?.current?.getBoundingClientRect();
    const readableTooltipPosition = getReadableTooltipPosition(currentCoordinates);
    setCurrPosition(readableTooltipPosition || position);
  }, [tooltipRef, position]);

  React.useEffect(() => {
    position && setCurrPosition(position);
  }, [position]);

  return (
    <Wrapper className={className} ref={tooltipRef}>
      <Popup
        closeOnDocumentClick
        closeOnEscape
        contentStyle={contentStyle}
        overlayStyle={overlayStyle}
        trigger={children}
        position={currPosition}
        on={['hover', 'click']}
      >
        <>{label}</>
      </Popup>
    </Wrapper>
  );
}

Tooltip.defaultProps = defaultProps;
export {Tooltip};
